// Versions.js （= APIラッパ。ファイル名は任意でOK）
import { API, graphqlOperation } from 'aws-amplify';
// 既存の import はそのまま
import { listAcsVersions as getAcsVersions } from './queries';
import { isUndefined } from './../../../shared/utils/misc';

/**
 * AcsVersion 一覧取得（全件 or active/keyword 絞り込み）
 * @param {{ active?: boolean, version?: string }} argFilter
 * @param {string|null} argNextToken
 * @param {number} argLimit
 * @returns {Promise<{items:any[], nextToken:string|null}>}
 */
export async function listAcsVersions(
  { ...argFilter } = {},
  argNextToken = null,
  argLimit = 500
) {
  const queryArgument = {
    // list は sortDirection を受けない（@key無し）
    nextToken: argNextToken,
    limit: argLimit,
  };

  const and = [];

  // active
  if (!isUndefined(argFilter.active)) {
    and.push({ active: { eq: argFilter.active } });
  }

  // version contains（任意：必要なければ渡さない）
  if (argFilter.version && String(argFilter.version).trim()) {
    and.push({ version: { contains: String(argFilter.version).trim() } });
  }

  if (and.length > 0) {
    queryArgument.filter = { and };
  }

  try {
    const resp = await API.graphql(graphqlOperation(getAcsVersions, queryArgument));
    return resp?.data?.listAcsVersions ?? { items: [], nextToken: null };
  } catch (e) {
    console.log('listAcsVersions error:', e);
    return { items: [], nextToken: null };
  }
}

/**
 * version が prefix（例: 'v1' / 'v2'）で始まるものだけ取得
 * @param {'v1'|'v2'|string} prefix
 * @param {{ active?: boolean, limit?: number, nextToken?: string }} options
 * @returns {Promise<{items:any[], nextToken:string|null}>}
 */
export async function listAcsVersionsByPrefix(
    prefix, 
    { ...argFilter } = {},
   argNextToken = null,
   argLimit = 500
) {

  const queryArgument = Object.assign({},{ 
    nextToken: argNextToken, 
    limit: argLimit
  })

  let queryFilter = {
    and:[]
  }

  // version
  queryFilter.and.push({ version: { beginsWith: prefix } });
  
  // active
  if (!isUndefined(argFilter.active)) {
    queryFilter.and.push({ active: { eq: argFilter.active } });
  }

    // and が空なら filter を送らない
  if (queryFilter.and.length > 0) {
    queryArgument.filter = queryFilter;
  }

  try {
    const resp = await API.graphql(
      graphqlOperation(getAcsVersions, queryArgument)
    );
    return resp?.data?.listAcsVersions ?? { items: [], nextToken: null };
  } catch (e) {
    console.log('listAcsVersionsByPrefix error:', e);
    return { items: [], nextToken: null };
  }
}

// ショートカット
export const listV1 = (opts) => listAcsVersionsByPrefix('v1', opts);
export const listV2 = (opts) => listAcsVersionsByPrefix('v2', opts);
